import React, {useEffect} from 'react'
import {useNavigate, useParams, useSearchParams} from 'react-router-dom'
import Step2Container from './Step2Container'
import {SelectedVariantProvider} from './context/SelectedVariantContext'
import Tour from '../../shared/tour'
import {getEnvironment} from '../../services/AuthServices'
import {getLocalData, setLocalData} from '../../services/StorageServices'
import {authorizeWithStoreSlug, fetchPublicStoreSettingsBySlug} from '../../services/SellerServices'
import {toaster} from '../../shared/PFToast'

const MockupGeneratorContainer = () => {
    const navigate = useNavigate()
    const [params] = useSearchParams()
    const {productId} = useParams()
    const env = getEnvironment()
    const getConfigValue = (envValue, paramKey, localKey) => {
        return env === 'development' 
            ? envValue 
            : params.get(paramKey) || getLocalData(localKey);
    };

    const path = getConfigValue(process.env.REACT_APP_PATH, 'path', 'path');
    const storeId = getConfigValue(process.env.REACT_APP_STORE_ID, 'storeId', 'storeId');
    const accessToken = getConfigValue(process.env.REACT_APP_ACCESS_TOKEN, 'accessToken', 'accessToken');
    const mappingProductId = params.get('mappingProductId')
    const variantId = params.get('variantId')
    const sku = params.get('sku')
    const isRemapFlow = params.get('isRemapFlow') === 'true'

    useEffect(() => {
        setLocalData('path', '')
        setLocalData('storeId', '')
    }, [])

    const _authorize = async (storeId) => {
        if (!storeId) return
        const {success, data, message} = await authorizeWithStoreSlug(storeId)
        if (!success) throw new Error(message)
        setLocalData('storeRoles', JSON.stringify(data.roles))
        setLocalData('storeSettings', JSON.stringify(data.settings))
    }

    const _fetchStoreSettings = async (storeId) => {
        if (!storeId) return
        const {success, data, message} = await fetchPublicStoreSettingsBySlug(storeId)
        if (!success) throw new Error(message)
        setLocalData('currentStoreSettings', JSON.stringify(data))
    }

    const _handleRedirect = async (storeId) => {
        try {
            await _fetchStoreSettings(storeId)
            await _authorize(storeId)
            if (productId && !mappingProductId) {
                // window.open(`${window.location.origin}/${productId}`, '_self')
                navigate(`/${productId}`, {replace: true})
            }
        } catch (error) {
            setLocalData('storeRoles', '')
            setLocalData('storeSettings', '')
            setLocalData('currentStoreSettings', '')
            setLocalData('accessToken', '')
            setLocalData('path', '')
            setLocalData('storeId', '')
        }
    }

    useEffect(() => {
        setLocalData('path', path)
        setLocalData('accessToken', accessToken)
    }, [path, accessToken])

    useEffect(() => {
        setLocalData('storeId', storeId)
        setLocalData('storeRoles', JSON.stringify([]))
        _handleRedirect(storeId)
    }, [productId, storeId])

    return (
        <SelectedVariantProvider>
            <div className="MockupGeneratorContainer">
                <Step2Container productId={productId} mappingProductId={mappingProductId} variantId={variantId} sku={sku} storeId={storeId} isRemapFlow={isRemapFlow} />
            </div>
        </SelectedVariantProvider>
    )
}

// eslint-disable-next-line import/no-anonymous-default-export
export default MockupGeneratorContainer

